import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Store } from "../store";
import { RouterModule } from "@angular/router";
import { SharedModule } from "../shared/shared.module";
import { NotificationsListComponent } from "./notifications-list/notifications-list.component";
import { NotificationsComponent } from "./notifications.component";
import { NotificationsRoutingModule } from "./notifications-routing.module";
import { AngularSvgIconModule } from "angular-svg-icon";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";

@NgModule({
    declarations: [NotificationsListComponent, NotificationsComponent],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        AngularSvgIconModule,
        SharedModule,
        NotificationsRoutingModule,
        BsDatepickerModule,
        BsDropdownModule,
    ],
    exports: [NotificationsListComponent],
    providers: [Store],
})
export class NotificationsModule {}
